import "@hotwired/turbo-rails"
import LocalTime from "local-time"
import './controllers'
LocalTime.start();